import React, { Component, Fragment } from "react";
import Content from "./Content";
import { Icon } from "antd";
import { NavButton, ButtonContainer } from "./../../StyledComponents";
import {
	setPaginationState,
	setSurveyAnswers,
	setSurveyON,
} from "./../../../../../../redux/actions/surveyActions";
import connect from "react-redux/es/connect/connect";
import ContentMedia from "./Content/ContentMedia";
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! local
const sendResponse = (idSurvey, response) => {
};
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! local

// SimulatedSurvey Component
class SimulatedSurvey extends Component {
	constructor(props) {
		super(props);
		this.state = {
			ltN: 0,
			lN: 0,
			sN: 0,
			firstPage: true,
			surveyOn: true,
			visit: {
				survey: this.props.surveyAnswers,
			},
		};
	}

	/*
	 ****************************
	 * FUNCTIONS *
	 ****************************
	 */

	setNewStates = (
		locationType,
		location,
		statement,
		mediaPage,
		kpiPage = 0
	) => {
		let firstPage = false;
		// If first page
		if (locationType === 0 && location === 0 && statement === 0) {
			firstPage = true;
		}
		// Set new states
		this.setState({
			ltN: locationType,
			lN: location,
			sN: statement,
			firstPage: firstPage,
			mediaPage: mediaPage,
			kpiPage: kpiPage,
		});

		this.props.setPaginationState(
			locationType,
			location,
			statement,
			!!firstPage,
			mediaPage,
			kpiPage
		);
	};

	nextOrPrev = (nav, ltN, lN, sN, sendResponse) => {
		switch (nav) {
			case "next":
				this.getNextState(ltN, lN, sN, sendResponse);
				break;
			case "prev":
				this.getPrevState(ltN, lN, sN, sendResponse);
				break;
			default:
				break;
		}
	};

	getPrevState = (ltN, lN, sN, sendResponse) => {
		const { firstPage, kpiPage } = this.props;

		let currentStatement = this.props.surveyAnswers[ltN].locations[lN]
			.statements[sN];
		const isDisplayMatrix = currentStatement.displayType === "matrix";

		let currentMediaPage = this.props.mediaPage - 1;
		if (/*isDisplayMatrix && */ currentMediaPage >= -1) {
			return this.setNewStates(
				ltN,
				lN,
				sN,
				currentMediaPage,
				isDisplayMatrix ? kpiPage : 0
			);
		}

		//has previous kpi page ?
		if (isDisplayMatrix && kpiPage > 0) {
			return this.setNewStates(ltN, lN, sN, -1, kpiPage - 1);
		}

		// Go to prev statement
		sN = sN - 1;
		// Get prev statement with correct locationType and location
		while (
			!firstPage &&
			!this.props.surveyAnswers[ltN].locations[lN].statements[sN]
		) {
			if (!firstPage) {
				// IF NO STATEMENT, UPDATE TO PREVIOUS LOCATION
				if (!this.props.surveyAnswers[ltN].locations[lN].statements[sN]) {
					console.log(
						"NO STATEMENT " +
							sN +
							" FOR LOCATION " +
							lN +
							" LOCATIONTYPE " +
							ltN
					);
					lN = lN - 1;
					sN =
						lN >= 0
							? this.props.surveyAnswers[ltN].locations[lN].statements.length -
							  1
							: sN;
				}
				// IF NO LOCATION, UPDATE TO PREVIOUS LOCATIONTYPE
				if (!this.props.surveyAnswers[ltN].locations[lN]) {
					console.log("NO LOCATION " + lN + " FOR LOCATIONTYPE " + ltN);
					ltN = ltN - 1;
					lN = this.props.surveyAnswers[ltN].locations.length - 1;
					sN =
						this.props.surveyAnswers[ltN].locations[lN].statements.length - 1;
				}
			}
		}
		this.setNewStates(ltN, lN, sN, -1, isDisplayMatrix ? kpiPage : 0);
	};

	getNextState = (ltN, lN, sN, kpis = [], sendResponse) => {
		const currentStatement = this.props.surveyAnswers[ltN].locations[lN]
			.statements[sN];
		const isDisplayMatrix = currentStatement.displayType === "matrix";

		//has next kpi page ?
		let kpiPage = this.props.kpiPage || 0;
		const kpiDisplayed = this.getKpisDisplayed(kpis);
		if (isDisplayMatrix && (kpiPage + 1) * 3 < kpiDisplayed.length) {
			kpiPage += 1;
			return this.setNewStates(ltN, lN, sN, -1, kpiPage);
		}

		//has next medias ?
		let currentStatementMediaQuantity = currentStatement.mediaQuantity || [];
		let currentMediaPage = this.props.mediaPage + 1;

		//const { quantity } = currentStatementMediaQuantity[currentMediaPage];
		while (currentMediaPage < currentStatementMediaQuantity.length) {
			const { quantity } = currentStatementMediaQuantity[currentMediaPage];
			if (!quantity || quantity === "0") {
				currentMediaPage++;
			} else {
				break;
			}
		}

		if (currentMediaPage < currentStatementMediaQuantity.length) {
			return this.setNewStates(ltN, lN, sN, currentMediaPage, kpiPage);
		}

		// Go to next statement
		sN = sN + 1;
		//this.setState({ sN });
		console.log(this.props.surveyAnswers[ltN].locations[lN].statements[sN]);
		// Get next statement with correct locationType and location
		while (!this.props.surveyAnswers[ltN].locations[lN].statements[sN]) {
			console.log("W H I L E");
			console.log(ltN + " " + lN + " " + sN);
			// IF NO STATEMENT, UPDATE TO NEXT LOCATION
			if (!this.props.surveyAnswers[ltN].locations[lN].statements[sN]) {
				console.log(
					"NO STATEMENT " + sN + " FOR LOCATION " + lN + " LOCATIONTYPE " + ltN
				);
				lN = lN + 1;
				sN = 0;
			}
			// IF NO LOCATION, UPDATE TO NEXT LOCATIONTYPE
			if (!this.props.surveyAnswers[ltN].locations[lN]) {
				console.log("NO LOCATION " + lN + " FOR LOCATIONTYPE " + ltN);
				ltN = ltN + 1;
				lN = 0;
				sN = 0;
			}
			// IF NO LOCATIONTYPE, END SURVEY
			if (!this.props.surveyAnswers[ltN]) {
				console.log("NO LOCATIONTYPE " + ltN);
				this.setState({ surveyOn: false });
				this.props.setSurveyON(false);
				break; // to avoid this while when survey is over
			}
		}
		this.setNewStates(ltN, lN, sN, -1, 0);
	};

	setConditionStatus = (ltN, lN, sN, c, status) => {
		// Ser current condition status (for one condition)
		this.props.surveyAnswers[ltN].locations[lN].statements[sN].conditions[
			c
		].status = status;
		// Set global conditions status (for all conditions of the statement)
		this.props.surveyAnswers[ltN].locations[lN].statements[sN].conditions
			.length > 0
			? this.props.surveyAnswers[ltN].locations[lN].statements[
					sN
			  ].conditions.map((condition, c) => {
					if (condition.status === false) {
						this.setResponse("dev-remove-responses", ltN, lN, sN);
						return (this.props.surveyAnswers[ltN].locations[lN].statements[
							sN
						].condition = false);
					} else {
						this.props.surveyAnswers[ltN].locations[lN].statements[
							sN
						].condition = true;
					}
			  })
			: null;
	};

	setResponse = (response, ltN, lN, sN, k, p) => {
		// If condition is set to false, remove all the responses of this statement's kpis
		const surveyAnswers = this.props.surveyAnswers || {};
		try {
			const kpis = surveyAnswers[ltN].locations[lN].statements[sN].kpis || [];
			const currentKpi = kpis[k] || {};

			let isKpiPos = false;
			let isFacing = false;
			let facingValue = 0;

			if (currentKpi.id === 1) {
				isFacing = true;
				facingValue = response;
			}

			if (currentKpi.id === 14 || currentKpi.id === 15) {
				isKpiPos = true;
				facingValue = response;
			}
			//FACING RULES
			if (isFacing) {
				//prevent pos from being > to facing
				for (let i = 0; i < kpis.length; i++) {
					const kpi = kpis[i];
					if (kpi.id === 14 || kpi.id === 15) {
						const kpiResponses = kpi.response || {};
						const posValue = kpiResponses[p] || 0;
						kpiResponses[p] = Math.min(facingValue, posValue);
					}
				}
			}

			//POS RULES
			//get Facing value
			if (isKpiPos) {
				for (let i = 0; i < kpis.length; i++) {
					const kpi = kpis[i];
					if (kpi.id === 1) {
						const kpiResponses = kpi.response || {};
						facingValue = parseInt(kpiResponses[p]) || 0;
					}
				}
			}

			//response cant be > to facingValue
			if (isKpiPos && response > facingValue) {
				return;
			}

			currentKpi.response = currentKpi.response || {};
			currentKpi.response[p] = response;
			console.log(
				`ltN=${ltN}, lN=${lN}, sN=${sN}, k=${k}, p=${p}, response=${response}`
			);
			console.log("set", surveyAnswers);
			this.props.setSurveyAnswers(surveyAnswers);
		} catch (e) {}
		return;
		this.props.surveyAnswers[ltN].locations[lN].statements[sN].kpis.map(
			(kpi, k) => {
				kpi.response = [];
			}
		);
		return;
		if (response === "dev-remove-responses") {
			this.props.surveyAnswers[ltN].locations[lN].statements[sN].kpis.map(
				(kpi, k) => {
					kpi.response = [];
				}
			);
		} else {
			this.props.surveyAnswers[ltN].locations[lN].statements[sN].condition
				? (this.props.surveyAnswers[ltN].locations[lN].statements[sN].kpis[
						k
				  ].response[p] = response)
				: (this.props.surveyAnswers[ltN].locations[lN].statements[sN].kpis[
						k
				  ].response = []);
		}
		console.log(this.props.surveyAnswers[ltN].locations[lN].statements[sN]);
		//this.setState({ visit: visit });
	};

	/*
	 ****************************
	 * RENDER *
	 ****************************
	 */

	/**
	 * Filter kpis, return kpis with surveyDisplay = true
	 */
	getKpisDisplayed(kpis = []) {
		const kpisDisplayed = [];
		for (let i = 0; i < kpis.length; i++) {
			const kpi = kpis[i];
			if (kpi && kpi.survey_display) {
				kpisDisplayed.push(kpi);
			}
		}
		return kpisDisplayed;
	}

	render() {
		const { ltN, lN, sN, firstPage, mediaPage, kpiPage, surveyOn } = this.props;

		if (surveyOn) {
			const currentStatement = this.props.surveyAnswers[ltN].locations[lN]
				.statements[sN];

			if (currentStatement && currentStatement.kpis) {
				const kpisDisplayed = this.getKpisDisplayed(currentStatement.kpis);
				if (
					kpisDisplayed &&
					kpiPage > 0 &&
					kpiPage * 3 >= kpisDisplayed.length
				) {
					this.setNewStates(ltN, lN, sN, -1, kpiPage - 1);
				}
			}

			const mediaQuantity = currentStatement
				? currentStatement.mediaQuantity[mediaPage]
				: {};
			return (
				<Fragment>
					{/* <div className="title">{visit.label}</div> */}
					{mediaPage >= 0 && currentStatement ? (
						<ContentMedia
							type={mediaQuantity.type}
							quantity={mediaQuantity.quantity}
						/>
					) : (
						<span />
					)}
					{mediaPage === -1 && currentStatement ? (
						<Content
							key={this.props.surveyAnswers[ltN].locationTypeId}
							locationType={this.props.surveyAnswers[ltN]}
							location={this.props.surveyAnswers[ltN].locations[lN]}
							statement={currentStatement}
							ltN={ltN}
							lN={lN}
							sN={sN}
							kpiPage={kpiPage}
							setResponse={this.setResponse}
							setConditionStatus={this.setConditionStatus}
							allProducts={this.props.products}
							condition={currentStatement.condition}
						/>
					) : (
						<span />
					)}
					<ButtonContainer>
						<NavButton
							disabled={
								firstPage && mediaPage === -1 && kpiPage === 0 ? true : false
							}
							onClick={() => this.getPrevState(ltN, lN, sN)}
						>
							Retour
						</NavButton>
						<NavButton
							onClick={() =>{
								if(!currentStatement || !currentStatement.kpis) return;
								this.getNextState(
									ltN,
									lN,
									sN,
									currentStatement.kpis,
									sendResponse
								)
							}}
						>
							Suivant
						</NavButton>
					</ButtonContainer>
				</Fragment>
			);
		} else {
			return (
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flex: 1,
						flexDirection: "column",
					}}
				>
					<span>Merci, le questionnaire est en cours d'envoi...</span>
					<Icon type="loading" theme="outlined" />
				</div>
			);
		}
	}
}

const mapStateToProps = (state, ownProps) => {
	let ranges = [];
	let products = [];
	let models = state.survey.surveyManager.surveyProgress.model;

	if (models && models[0]) {
		if (models[0].ranges) {
			ranges = models[0].ranges;
		}

		if (models[0].products) {
			products = models[0].products;
		}
	}

	return {
		ltN: state.survey.simulationManager.ltN,
		lN: state.survey.simulationManager.lN,
		sN: state.survey.simulationManager.sN,
		firstPage: state.survey.simulationManager.firstPage,
		kpiPage: state.survey.simulationManager.kpiPage,
		mediaPage: state.survey.simulationManager.mediaPage,
		surveyOn: state.survey.simulationManager.surveyOn,
		surveyAnswers: state.survey.simulationManager.surveyAnswers,
		products: products,
		ranges: ranges,
		locationTypes: state.survey.simulationManager.locationTypes,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		setSurveyON: surveyOn => {
			dispatch(setSurveyON(surveyOn));
		},
		setPaginationState: (ltN, lN, sN, firstPage, mediaPage, kpiPage = 0) => {
			dispatch(setPaginationState(ltN, lN, sN, firstPage, mediaPage, kpiPage));
		},
		setSurveyAnswers: surveyAnswers => {
			dispatch(setSurveyAnswers(surveyAnswers));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SimulatedSurvey);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/surveyStep/SimulatedSurvey/SimulatedSurvey.js